import { Scenario } from './types';

export const SCENARIOS: Scenario[] = [
  {
    id: 'Studio',
    name: 'Studio Fotografico',
    description: 'Premium Commercial Set con setup luci LED avanzato e look minimale.',
    imageUrl: 'https://images.unsplash.com/photo-1541443131876-44b03de101c5?auto=format&fit=crop&q=80&w=800',
    prompt: `STUDIO FOTOGRAFICO — "Premium Commercial Set". Photorealistic studio environment: clean, premium, minimal.
    LIGHTING RIG: Overhead LED setup with two visible elements: a circular ring light above the car and a hexagonal LED grid (honeycomb-style) slightly offset.
    These create realistic, controlled reflections on the car and wrap.
    ENVIRONMENT: Minimal seamless studio background (dark), professional look. Clean floor with epoxy/cement texture and controlled reflections.
    REALISM MICRO-DETAILS: A few thin cables barely visible near edges, a partially cropped C-stand in one corner, small strips of black gaffer tape on the floor.
    Very light haze in the air. The wrap must remain sharp and readable.`
  },
  {
    id: 'Urban',
    name: 'Night Run / Urban',
    description: 'Scena notturna dinamica in distretto business con motion blur e riflessi premium.',
    imageUrl: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?auto=format&fit=crop&q=80&w=800',
    prompt: `URBAN SCENARIO — "Night Run / Premium Motion". Photorealistic urban scene in a modern business district during blue hour / early night.
    CAMERA & MOTION: The car is moving fast, panning technique. The wrap/livery must stay sharp and clearly readable.
    Background shows controlled motion blur (light streaks). Wheels show radial rotation blur while the car body remains crisp.
    LIGHTING: Urban street lights + soft signage glow as key light for realistic vinyl reflections. Subtle blue ambient fill from the sky.
    ENVIRONMENT DETAILS: Worn road markings, asphalt texture with imperfections, manholes, distant cars in soft bokeh, street lamps.
    Cinematic, premium, believable vibe.`
  },
  {
    id: 'Paddock',
    name: 'Paddock — Track Grit',
    description: 'Atmosfera motorsport autentica, asfalto vissuto e illuminazione solare decisa.',
    imageUrl: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&q=80&w=800',
    prompt: `PADDOCK SCENARIO — "Track Grit (Race Day)". Photorealistic real paddock/pit-lane environment: functional, industrial, slightly dirty, with authentic racing textures.
    LIGHTING: Daylight with a slightly harsh, directional sun. Strong contrast: crisp shadows, realistic highlights. Subtle bounce light from concrete/asphalt. Reflections feel "outdoor real", textured, track-authentic. No glossy showroom reflections.
    GROUND & TEXTURE: Asphalt/concrete with real imperfections: patches, fine cracks, rubber marks, tire scuffs, darker braking marks. Subtle dust/grit on the ground.
    SECOND-PLANE DETAILS: Pit wall barriers, red/white blocks, fencing, traffic cones, tire stack, tool trolley, track signage, softly out of focus.
    COMPOSITION: Car fully in frame with breathing space, 3/4 angle (left-biased).
    WRAP PROTECTION: Wrap/livery must remain sharp, readable, and consistent. Photorealistic, slightly rough, race-day authenticity.`
  },
  {
    id: 'Exhibition',
    name: 'Exhibition Hall — Spotlight',
    description: 'Atmosfera premium da salone dell\'auto europeo con luci spot e pubblico discreto.',
    imageUrl: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&q=80&w=800',
    prompt: `EXHIBITION SCENARIO — "European Car Show (Spotlight)". Photorealistic modern indoor car show hall: neutral, clean, slightly dark.
    CORE IDEA: The car is showcased on a small premium dark platform/podium.
    LIGHTING: Low ambient light + sharp controlled spotlights focused on the car. Realistic show reflections on the wrap. Subtle rim light for silhouette separation.
    ENVIRONMENT: Dark grey/charcoal tones, minimal branding. Matte or lightly reflective professional floor.
    PEOPLE: A few people around observing, slightly out of focus or partially cropped. They must not steal attention; no strong colors or faces as main subjects.
    DETAILS: Velvet ropes, stanchions, distant soft signage, overhead truss lighting hinted above.
    COMPOSITION: Entire car in frame, 3/4 angle (left-biased). Wrap/livery must remain sharp, readable, and consistent.`
  }
];

export const VIEWS = [
  { id: 'front', label: 'Front 3/4', description: 'Showcases Hood + Front Bumper + Side Left' },
  { id: 'rear', label: 'Rear 3/4', description: 'Showcases Trunk + Rear Bumper + Side Left' },
  { id: 'top', label: 'Drone Top', description: 'True overhead view showcasing Roof + Full Silhouette' }
];
